// @flow
import type { State, Action } from './types';

const initialState: State = {
  teamInfo: {
    info: null,
    fetching: false,
    error: false,
  },
  teamSchedule: {
    fetching: false,
    teamSchedule: [],
    error: false,
  },
  teamStandings: {
    fetching: false,
    teamStandings: {},
    error: false,
  },
  opponentInfo: {
    info: null,
    fetching: false,
    error: false,
  },
  upcomingGames: {
    fetching: false,
    error: false,
    content: [],
  },
  gamesInfo: {
    games: [],
    fetching: false,
    error: false,
  },
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'REQUEST_TEAM_INFO': {
      return {
        ...state,
        teamInfo: {
          info: null,
          fetching: true,
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_INFO': {
      const { payload } = action;
      return {
        ...state,
        teamInfo: {
          fetching: false,
          info: { ...payload },
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_INFO_ERROR': {
      return {
        ...state,
        teamInfo: {
          fetching: false,
          info: null,
          error: true,
        },
      };
    }
    case 'REQUEST_OPPONENT_INFO': {
      return {
        ...state,
        opponentInfo: {
          fetching: true,
          info: null,
          error: false,
        },
      };
    }
    case 'RECEIVE_OPPONENT_INFO': {
      const { payload } = action;

      return {
        ...state,
        opponentInfo: {
          fetching: false,
          info: { ...payload },
          error: false,
        },
      };
    }
    case 'RECEIVE_OPPONENT_INFO_ERROR': {
      return {
        ...state,
        opponentInfo: {
          fetching: false,
          info: null,
          error: true,
        },
      };
    }
    case 'REQUEST_TEAM_SCHEDULE': {
      return {
        ...state,
        teamSchedule: {
          fetching: true,
          teamSchedule: [],
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_SCHEDULE': {
      const { payload } = action;
      return {
        ...state,
        teamSchedule: {
          fetching: false,
          teamSchedule: payload.length > 0 ? payload : [],
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_SCHEDULE_ERROR': {
      return {
        ...state,
        teamSchedule: {
          fetching: false,
          teamSchedule: [],
          error: true,
        },
      };
    }
    case 'REQUEST_TEAM_STANDINGS': {
      return {
        ...state,
        teamStandings: {
          fetching: true,
          teamStandings: {},
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_STANDINGS': {
      const { payload } = action;
      return {
        ...state,
        teamStandings: {
          fetching: false,
          teamStandings: payload,
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_STANDINGS_ERROR': {
      return {
        ...state,
        teamStandings: {
          fetching: false,
          teamStandings: {},
          error: true,
        },
      };
    }
    case 'REQUEST_TEAM_GAMES': {
      return {
        ...state,
        gamesInfo: {
          fetching: true,
          games: [],
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_GAMES': {
      const { payload } = action;
      return {
        ...state,
        gamesInfo: {
          fetching: false,
          games: payload,
          error: false,
        },
      };
    }
    case 'RECEIVE_TEAM_GAMES_ERROR':
      return {
        ...state,
        teamStandings: {
          fetching: false,
          teamStandings: {},
          error: true,
        },
      };

    // SWITCHING TO NEW VERSION

    case 'REQUEST_UPCOMING_GAMES':
      return {
        ...state,
        upcomingGames: {
          fetching: true,
          error: false,
          content: [],
        },
      };
    case 'RECEIVE_UPCOMING_GAMES': {
      const { payload } = action;
      return {
        ...state,
        upcomingGames: {
          fetching: false,
          error: false,
          content: payload,
        },
      };
    }
    case 'RECEIVE_UPCOMING_GAMES_ERROR': {
      return {
        ...state,
        upcomingGames: {
          fetching: false,
          error: true,
          content: [],
        },
      };
    }

    // END OF NEW VERSIONING

    default:
      /* Following line assures switch exhaustiveness */
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
